import { useCallback } from "react";

const useCrearValidacionHojaQXHandlers = ({
  confirmarEliminarCobertura,
  handleEliminarCobertura,
  confirmarEliminarAnexo,
  handleEliminarAnexo,
  handleCerrarCoberturasDuplicadasModal,
  resultadoEnvioPendiente,
  setResultadoEnvio,
  setShowResultadoEnvioModal,
  setResultadoEnvioPendiente,
  handleSubmitHojaQuirurgica,
  handleCloseHojaQuirurgicaModal,
}) => {
  const handleConfirmarEliminarCobertura = useCallback(() => {
    confirmarEliminarCobertura(handleEliminarCobertura);
  }, [confirmarEliminarCobertura, handleEliminarCobertura]);

  const handleConfirmarEliminarAnexo = useCallback(() => {
    confirmarEliminarAnexo(handleEliminarAnexo);
  }, [confirmarEliminarAnexo, handleEliminarAnexo]);

  const handleCerrarCoberturasDuplicadas = useCallback(() => {
    handleCerrarCoberturasDuplicadasModal(() => {
      if (resultadoEnvioPendiente) {
        setResultadoEnvio(resultadoEnvioPendiente);
        setShowResultadoEnvioModal(true);
        setResultadoEnvioPendiente(null);
      }
    });
  }, [
    handleCerrarCoberturasDuplicadasModal,
    resultadoEnvioPendiente,
    setResultadoEnvio,
    setShowResultadoEnvioModal,
    setResultadoEnvioPendiente,
  ]);

  const handleSubmitForm = useCallback(
    async (formData) => {
      const success = await handleSubmitHojaQuirurgica(formData);
      if (success) {
        handleCloseHojaQuirurgicaModal();
      }
    },
    [handleSubmitHojaQuirurgica, handleCloseHojaQuirurgicaModal]
  );

  return {
    handleConfirmarEliminarCobertura,
    handleConfirmarEliminarAnexo,
    handleCerrarCoberturasDuplicadas,
    handleSubmitForm,
  };
};

export default useCrearValidacionHojaQXHandlers;

